import { onLoad } from "@/utils/_"

const plugin: NuxtPlugin = ({ isDev }) => {
  if (isDev) return
  const id = "chbzgzzo"
  if (!id) return

  onLoad(() => {
    const script = document.createElement("script")
    script.text = `
      (function (t, l, g, r, m) {
        if (!t[g]) {
          const f = function () {
            f.run ? f.run.apply(f, arguments) : f.queue.push(arguments)
          }
          f.queue = []
          t[g] = f
          const s = l.createElement(r)
          s.async = true
          s.src = m
          const el = l.getElementsByTagName(r)[0]
          el.parentNode.insertBefore(s, el)
        }
      })(window, document, "tgp", "script", "https://telegram.org/js/pixel.js")
      window.tgp?.("init", "${id}")
    `
    document.body.appendChild(script)
  })
}

export default plugin
